import React from "react";
import { Button } from "antd";
import { LeftOutlined } from '@ant-design/icons';

export interface BackButtonProps {
  /** 点击事件 */
  onClick?: () => void;
  /** 是否显示文字 */
  showText?: boolean;
  /** 自定义类名 */
  className?: string;
  /** 按钮大小 */
  size?: "small" | "middle" | "large";
  /** 按钮类型 */
  type?: "primary" | "default" | "dashed" | "link" | "text";
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<BackButtonProps> & { __docgenInfo?: DocgenInfo };

/** 返回按钮组件 */
export const BackButton: React.FC<BackButtonProps> = ({ 
  onClick, 
  showText = false,
  className,
  size = "small",
  type = "default"
}) => {
  return (
    <Button
      size={size}
      type={type}
      icon={<LeftOutlined />}
      className={`cursor-pointer ${className || ''}`}
      onClick={onClick}
    >
      {showText && "返回"}
    </Button>
  );
};

// 手动添加 docgen 信息
(BackButton as ComponentWithDocgen).__docgenInfo = {
  displayName: "BackButton",
  description: "返回按钮组件",
  props: {
    onClick: {
      name: "onClick",
      required: false,
      description: "点击事件",
      type: { name: "function", raw: "() => void" }
    },
    showText: {
      name: "showText",
      required: false,
      description: "是否显示文字",
      type: { name: "boolean", raw: "boolean" },
      defaultValue: { value: "false" }
    },
    className: {
      name: "className",
      required: false,
      description: "自定义类名",
      type: { name: "string", raw: "string" }
    },
    size: {
      name: "size",
      required: false,
      description: "按钮大小",
      type: { name: "ButtonSize", raw: '"small" | "middle" | "large"' },
      defaultValue: { value: '"small"' }
    },
    type: {
      name: "type",
      required: false,
      description: "按钮类型",
      type: { name: "ButtonType", raw: '"primary" | "default" | "dashed" | "link" | "text"' },
      defaultValue: { value: '"default"' }
    }
  }
};
